import { render, staticRenderFns } from "./ChatInterface.vue?vue&type=template&id=153a8d85&scoped=true"
import script from "./ChatInterface.vue?vue&type=script&lang=ts"
export * from "./ChatInterface.vue?vue&type=script&lang=ts"
import style0 from "./ChatInterface.vue?vue&type=style&index=0&id=153a8d85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a8d85",
  null
  
)

export default component.exports